<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
            <el-col :span="10">
          <el-input placeholder="输入船名进行搜索..." v-model.trim="query.search"
                    @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" :loading="searching" @click="handleSearch">搜索</el-button>
          </el-input>
            </el-col>
            <el-col :span="6">
          <el-select placeholder="请选择业务部门" v-model="query.department" filterable clearable @change="handleSearch">
            <el-option v-for="g in groupList" :key="g.id" :value="g.name"></el-option>
          </el-select>
          </el-col>  
        <el-col :span="14">
          <el-button type="primary" size="small" icon="el-icon-files" :loading="downloading" @click="handleBatchDown">批量下载</el-button>
          <!-- <el-button type="primary" size="small" icon="el-icon-s-claim"
            @click="showBatchSendDialog">批量签署
          </el-button> -->
          <el-button type="primary" size="small" icon="el-icon-s-claim"
            @click="handleReceiptPrint">打印回执
          </el-button>
        </el-col>
        </el-row>
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText"
                  fit highlight-current-row class="w-100" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          
          <!-- 选择凭证 -->
          <!-- <el-table-column align="left" label="选择" width="80px">
            <template slot-scope="scope">
              <el-checkbox :label="scope.row" :checked="isCheck(scope.row)">&nbsp;</el-checkbox>
            </template>
          </el-table-column> -->
  
          <!-- 船舶名称 -->
          <el-table-column align="left" label="凭证号">
            <template slot-scope="scope">
              <!-- <span>{{scope.row.number}}</span> -->
              <el-button type="text" @click="downloadPDF(scope.row)">{{scope.row.number}}</el-button>
            </template>
          </el-table-column>

          <el-table-column align="left" label="活动期数">
            <template slot-scope="scope">
              <span>{{ scope.row.activity_name }}</span>
            </template>
          </el-table-column>
  
          <!-- 保险公司 -->
          <el-table-column align="left" label="船名" >
            <template slot-scope="scope">
              <span>{{ scope.row.ship_name }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="会员" prop="member_name" ></el-table-column>
  
          <!-- 险种 -->
          <el-table-column align="left" label="部门">
            <template slot-scope="scope">
              <span>{{ scope.row.department }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="生成时间" width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
  
          <!-- 起保日期 -->
          <!-- <el-table-column align="left" label="单号" >
            <template slot-scope="scope">
              <span>{{ scope.row.number }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column property="operation" label="附件下载" width="200">
                  <template slot-scope="scope">
                      <el-tooltip effect="light" content="下载" placement="top-start">
                        <el-button type="warning" size="small" @click="downloadPDF(scope.row)">下载电子凭证</el-button>
                      </el-tooltip> -->
                      <!-- <el-tooltip effect="light" content="下载" placement="top-start">
                        <el-button type="warning" size="small" @click="download(scope.row)">下载回执</el-button>
                      </el-tooltip>
                      <span v-if="(scope.row.file !== null) && (scope.row.file.id)">
                        &nbsp;
                        <el-tooltip effect="light" content="发送签署" placement="top-start">
                          <el-button type="text" v-show="[1,2].indexOf(scope.row.file.status) == -1" @click="showSendDialog(scope.row)">
                            <i class="el-icon-s-claim"></i>
                          </el-button>
                        </el-tooltip>

                        <el-tooltip effect="light" content="签署链接" placement="top-start">
                          <el-button type="text" v-show="(scope.row.file.file_sign.length != 0) && (scope.row.file.file_sign[0].receiver)"
                                    @click="signUrl(scope.row.file.file_sign[0].id)"><i class="el-icon-link"></i></el-button>
                        </el-tooltip>
                        <el-tooltip effect="light" content="催签" placement="top-start">
                          <el-button type="text" v-show="(scope.row.file.file_sign.length != 0) && (scope.row.file.file_sign[0].receiver)"
                                    @click="handleUrgeSign(scope.row.file.file_sign[0].id)"><i class="el-icon-alarm-clock"></i></el-button>
                        </el-tooltip>
                        <el-tooltip effect="light" content="撤销" placement="top-start">
                          <el-button type="text" v-show="(scope.row.file.file_sign.length != 0) && [0, 1].indexOf(scope.row.file.file_sign[0].sign_flow_status) !== -1"
                                    @click="handleRevokeSign(scope.row.file.file_sign[0].id)"><i class="el-icon-s-release"></i></el-button>
                        </el-tooltip>
                        <el-tooltip effect="light" content="下载已签署回执" placement="top-start">
                          <el-button type="text" v-show="scope.row.file && scope.row.file.status === 2"
                                    @click="downloadSignFile(scope.row.file.child_obj)"><i class="el-icon-download"></i></el-button>
                        </el-tooltip>
                      </span> -->
                      <!-- </template>
          </el-table-column> -->
        </el-table>
      </el-card>
  
      <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total" @updateList="getList"></pagination>
      <el-dialog title="签署人选择" :visible.sync="dialogSendVisible" :show-close="false">
        <el-form label-position="left" label-width="150px">
          <el-form-item label="签署方类型">
            <el-radio-group v-model="signer_type">
              <el-radio :label="0">个人</el-radio>
              <el-radio :label="1">公司</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="签署人">
            <el-select v-model="signer_mobile" filterable placeholder="请选择签署人">
              <el-option v-for="contact in contacts" :key="contact.id" 
              :label="contact.name + '(' + restricted_mobile(contact.mobile) + ')'"
              :value="contact.mobile"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="signer_type === 1" label="签署方公司名称">
            <el-select placeholder="请选择签署方公司名称" filterable remote reserve-keyword :loading="org_loading"
                      :remote-method="remoteSearch" v-model="signer_org_name" class="w-75">
              <el-option v-for="org in org_list" :key="org.id" :label="org.name" :value="org.name"></el-option>
            </el-select>
            <!-- <el-select v-model="signer_org_name" filterable placeholder="请选择签署方公司名称">
              <el-option v-for="org in org_list" :key="org.id"
                  :label="org.name" :value="org.name"></el-option>
            </el-select> -->
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCancelSend">取 消</el-button>
          <el-button :disabled="signer_mobile === ''" type="primary" @click="sendSign">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="pdfname" :visible.sync="previewVisible">
        <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
      </el-dialog>
    </div>
  </template>
  <script>
  import Pagination from '@/components/Pagination'
  import {signFile, urgeSign, revokeSign, getSignUrl} from '@/api/sign'
  import {download as downloadSignFile} from '@/utils'
  import { fetchList as fetchGroupList } from "@/api/group";
  import { fetchAllContacts } from "@/api/contact"
  import { CertificateList,downCertificateFile, batchDownCertificate, fetchCertificateContactList, createInsuranceReceipt} from '@/api/group-insurance'
  import VuePdfPreview from "@/components/VuePdfPreview"

  export default {
  name: "policy-list",
    components: {
      Pagination,
      VuePdfPreview
    },
    data(){
      return {
        query:{
          search: '',
          limit: 10,
          offset: 0
        },
        loadingText: '正在加载数据，请稍等...',
        loading: false,
        searching: false,
        total: 0,
        list:[],
        checkList: [],
        groupList:[],
        downloading: false,
        dialogSendVisible: false,
        contacts: [],
        org_list: [],
        signer_mobile: '',
        signer_type: 0,
        signer_org_name: '',
        org_loading: false,
        file: {},
        sendType: "",
        previewVisible: false,
        pdfname: '',
        pdfUrl: '',
      }
    },
    methods: {
      downloadSignFile,
      restricted_mobile(mobile) {
        if (mobile && !this.$perm(['contact.list_contact']) && !this.$perm(['contact.all_contact']) && this.$perm(['contact.restricted_list_contact'])) {
          let value = mobile.slice(0, 3)
          var l = mobile.slice(3, 7).length
          for (var i=0; i<l; i++) {
            value += '*'
          }
          value += mobile.slice(7)
          return value
        }
        return mobile
      },
      getList() {
        this.loading = true
        CertificateList(this.query)
            .then(resp => {
              this.list = resp.results
              this.total = resp.count
              this.loading = false
            })
            .catch(error => {
              this.loading = false
              this.$message.error(error)
            })
      },
      handleSearch(val) {
          // this.getList()
          this.$refs.pagination.backNumOne()
      },
      handleView(id) {
        this.$router.push({ name: 'viewPolicy', query: { id: id } })
      },
  
      handleImport() {
        this.$router.push({ name: 'importPolicy'})
      },
      downloadPDF(form) {
        form.type = "pdf"
        this.loading = true
        this.downloadingText = '正在加载电子凭证，请稍等...'
        
        downCertificateFile(form)
          .then(res => {
            // this.pdfname = form.number
            // this.pdfUrl = res.url
            // this.previewVisible = true
            window.open(res.url, '_blank');
            // window.location.href = res.url
            // this.$message.success("下载完成")
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$error_message(error)
          })
      },
      download(form) {  
        form.type = "word"    
        this.loading = true
        this.downloadingText = '正在下载回执，请稍等...'
        this.$message.success(this.downloadingText)
        downCertificateFile(form)
          .then(res => {
            window.location.href = res.url
            this.$message.success("下载完成")
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$error_message(error)
          })
      },
      // isCheck(row) {
      //   let is_check = false
      //   for (var i = 0; i < this.checkList.length; i++) {
      //     if (this.checkList[i].id === row.id) {
      //       is_check = true
      //       break;
      //     }
      //   }
      //   return is_check
      // },
      handleSelectionChange(val) {
        this.checkList = val;
      },
      handleBatchDown() {
        if (this.checkList.length === 0) {
          this.$error_message("请选择需下载附件的保单")
        } else {
          let certificate_ids = []
          this.downloading = true
          this.checkList.forEach(element => {
            certificate_ids.push(element.id)
          })
          batchDownCertificate({certificate_ids: certificate_ids}).then(res=>{
            this.downloading = false
            window.location.href = res.url
            this.$message.success("下载完成")
          }).catch(error =>{
            this.downloading = false
            this.$error_message(error)
          })
        }
      },
      handleCancelSend() {
        this.dialogSendVisible = false
        this.signer_mobile = ''
        this.file = {}
      },
      remoteSearch(search) {
        if (search !== '') {
          this.org_loading = true
          fetchCustomerList({search: search, type: '0'})
            .then(res => {
              this.org_list = Object.assign([], res)
              this.org_loading = false
            })
            .catch(error => {
              this.org_loading = false
              this.$error_message(error)
            })
        } else {
          this.org_list = []
        }
      },
      showSendDialog(row) {
        fetchAllContacts()
        .then(res => {
          this.contacts = res
          this.dialogSendVisible = true
          this.file = row.file
          this.sendType = "single"
        })
        .catch(err => {
          this.$error_message(err)
        })
        // fetchCertificateContactList(row.id)
        // .then(res => {
        //   this.contacts = res.contact_list
        //   this.org_list = res.org_list
        //   this.dialogSendVisible = true
        //   this.file = row.file
        //   this.sendType = "single"
        // })
        // .catch(err => {
        //   this.$error_message(err)
        // })
      },
      showBatchSendDialog() {
        // const insurance_names = new Set();
        const files = new Array()
        var _index = 0
        var sign_names = []
        var no_file_names = []

        if (this.checkList.length === 0) {
          this.$error_message("请选择最少一个签署对象")
          return
        }

        this.checkList.forEach(item => {
          // insurance_names.add(item.ship_name)
          if (item.file.file_sign && item.file.file_sign.length > 0) {
            sign_names.push(item.ship_name)
          }
          else if ((item.file !== null) && (item.file.id)) {
            files.push(item.file)
          }
          else {
            no_file_names.push(item.ship_name)
            _index += 1
          }
        });

        if (sign_names.length > 0) {
          this.$error_message(sign_names.join(",") + " 回执已发起签署，请勿重复发起")
          return
        }

        if (_index > 0) {
          this.$error_message(no_file_names.join(",") + " 回执已签署或未生成，请检查")
          return
        }

        fetchAllContacts()
        .then(res => {
          this.contacts = res
          this.dialogSendVisible = true
          this.sendType = "multiple"
          this.$set(this.file, 'file_list', files)
        })
        .catch(err => {
          this.$error_message(err)
        })

        // if (insurance_names.size !== 1) {
        //   this.$error_message("所选投保对象不一致，请检查")
        //   return
        // }

        // fetchCertificateContactList(this.checkList[0].id)
        // .then(res => {
        //   this.contacts = res.contact_list
        //   this.org_list = res.org_list
        //   this.dialogSendVisible = true
        //   this.sendType = "multiple"
        //   this.$set(this.file, 'file_list', files)
        // })
        // .catch(err => {
        //   this.$error_message(err)
        // })
      },
      sendSign() {
        var text = ''
        if (this.sendType === 'single') {
          console.log("单一签署")
          text = '是否发送文书' + '《' + this.file.name + '》至' + this.restricted_mobile(this.signer_mobile) + '进行签署？'
        }
        else if (this.sendType === 'multiple') {
          console.log("批量签署")
          text = '是否批量发送文书至' + this.restricted_mobile(this.signer_mobile) + '进行签署？'
        }
        
        console.log(this.file)
        this.$confirm(text, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$set(this.file, 'signer_mobile', this.signer_mobile)
          this.$set(this.file, 'file_type', 'group_insurance_receipt')
          this.$set(this.file, 'send_type', this.sendType)
          this.$set(this.file, 'signer_type', this.signer_type)
          this.$set(this.file, 'signer_org_name', this.signer_type === 1 ? this.signer_org_name : '')
          this.loading = true
          signFile(this.file)
          .then(res => {
            this.loading = false
            this.$message({
              type: 'success',
              message: '已通知手机号为: ' + this.restricted_mobile(this.signer_mobile) + ' 的客户进行签署'
            });
            this.getList()
          })
          .catch((err) => {
            this.loading = false
            this.$message.error({
              message: err
            });
          })

          this.dialogSendVisible = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消发送签署'
          });       
        });
      },
      handleUrgeSign(sign_id) {
        this.loading = true
        urgeSign(sign_id)
        .then(res => {
          this.loading = false
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '已发送催签短信'
            })
          }
          else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
      },
      signUrl(sign_id) {
        getSignUrl(sign_id)
        .then(res => {
          if (res.code === 0) {
            this.$alert('签署链接为：' + res.data.shortUrl)
          }
          else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
      },
      loadData() {
          this.loading = true
          let p = []
          p.push(fetchGroupList())

          Promise.all(p)
          .then(res => {
            this.groupList = res[0]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
      handleRevokeSign(sign_id) {
        this.$confirm('是否撤销签署', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          revokeSign({'sign_id': sign_id}).then(res => {
            this.loading = false
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '已撤销签署'
              })
              this.getList()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          })
          .catch(err => {
            this.loading = false
            console.log(err)
          })
        })
      },
      handleReceiptPrint() {
        if (this.checkList.length === 0) {
          this.$error_message("请选择需打印回执的凭证")
        } else {
          let certificate_ids = []
          let file_name = `${this.checkList[0]["ship_name"]}_${this.checkList.length}_签收回执.docx`
          this.downloading = true
          this.checkList.forEach(element => {
            certificate_ids.push(element.id)
          })
          createInsuranceReceipt({'certificate_ids': certificate_ids})
            .then(res => {
              // console.log('res', res)
              this.downloading = false
              let link = document.createElement('a')
              link.style.display = 'none'

              let blob = new Blob([res])
              link.href = URL.createObjectURL(blob)

              link.download = file_name
              document.body.appendChild(link)

              link.click()
              URL.revokeObjectURL(blob)
              document.body.removeChild(link)
              this.getList()
              this.$message.success("成功打印回执")
            })
            .catch(error => {
              // console.log('err', error)
              this.downloading = false
              // 处理错误响应
              if (error instanceof Blob) {
                // 如果错误是Blob类型，使用FileReader读取内容
                const reader = new FileReader()
                reader.onload = (e) => {
                  try {
                    // 尝试解析JSON响应
                    const errorObj = JSON.parse(e.target.result)
                    const errorMessage = errorObj.message || '操作失败'
                    this.$message.error(errorMessage)
                  } catch (parseError) {
                    // 如果无法解析JSON，使用原始文本
                    this.$message.error('操作失败: ' + e.target.result)
                  }
                }
                reader.onerror = () => {
                  this.$message.error('无法读取错误信息')
                }
                reader.readAsText(error)
              } else {
                // 处理普通错误
                const errorMessage = error && error.message ? error.message : String(error)
                this.$message.error(errorMessage)
              }
            })
          }
      }
    },
    created(){
      this.getList()
      this.loadData()
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  